import type { BlockType } from '@model/editor-js/blocks';
import BlockCode from './blocks/block-code.vue';
import BlockColumns from './blocks/block-columns.vue';
import BlockCtaProducts from './blocks/block-cta-products.vue';
import BlockDelimiter from './blocks/block-delimiter.vue';
import BlockDownload from './blocks/block-download.vue';
import BlockEmbed from './blocks/block-embed.vue';
import BlockFaq from './blocks/block-faq.vue';
import BlockHeader from './blocks/block-header.vue';
import BlockHighlightProductCard from './blocks/block-highlight-product-card.vue';
import BlockHighlight from './blocks/block-highlight.vue';
import BlockImageGallery from './blocks/block-image-gallery.vue';
import BlockImage from './blocks/block-image.vue';
import BlockList from './blocks/block-list.vue';
import BlockParagraph from './blocks/block-paragraph.vue';
import BlockQuote from './blocks/block-quote.vue';
import BlockTable from './blocks/block-table.vue';
import type { Component, FunctionalComponent } from 'vue';

/**
 * Blocks whose content lives outside the body (related articles need fetched posts, case-study blocks
 * feed the RC sidebar). The renderer exposes them as named slots so the page can fill them.
 */
export const SLOT = 'slot';

/** Legacy `quote` blocks have never been rendered; their migration is tracked separately. */
const RendersNothing: FunctionalComponent = () => null;

/** Every block type must map to a renderer: a missing entry is a compile error. */
export const BLOCK_COMPONENTS = {
    paragraph: BlockParagraph,
    header: BlockHeader,
    list: BlockList,
    table: BlockTable,
    delimiter: BlockDelimiter,
    image: BlockImage,
    imagegallery: BlockImageGallery,
    quotetool: BlockQuote,
    highlighttool: BlockHighlight,
    codeblocktool: BlockCode,
    embed: BlockEmbed,
    faq: BlockFaq,
    downloadtool: BlockDownload,
    ctaoneproducttool: BlockCtaProducts,
    ctatwoproductstool: BlockCtaProducts,
    ctathreeproductstool: BlockCtaProducts,
    highlightproductcard: BlockHighlightProductCard,
    columns: BlockColumns,
    quote: RendersNothing,
    relatedarticles: SLOT,
    caseStudyLeftBlock: SLOT,
    caseStudyLeftLogo: SLOT,
} satisfies Record<BlockType, Component | typeof SLOT>;
